import _userbase from "userbase-js";
import { authProxy } from "./state";

_userbase.init({ appId: "67425134-fe6c-4f8d-90a4-8e78af47f905" }).then(session => {
  if (session.user) {
    authProxy.user = session.user;
  }
})

export const userbase = _userbase;